import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import { GraduationCap, ArrowRight, BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';

const FormationPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-indigo-50">
      <Navigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/" label="Retour à l'accueil" />
      </div>

      <div className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-purple-100 rounded-full px-4 py-2 mb-4">
              <GraduationCap className="h-5 w-5 text-purple-600" />
              <span className="text-purple-600 text-sm font-semibold">FORMA'SCOP</span>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Formation
            </h1>
            <p className="text-lg text-gray-600">
              Développement des compétences et transmission des savoir-faire
            </p>
          </div>

          <Card className="shadow-xl">
            <CardHeader className="text-center bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-t-lg">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <BookOpen className="h-8 w-8" />
              </div>
              <CardTitle className="text-2xl">
                FORMA'SCOP - À venir
              </CardTitle>
            </CardHeader>
            <CardContent className="p-4 md:p-8">
              <div className="text-center space-y-6">
                <p className="text-lg text-gray-700">
                  Notre offre de formation FORMA'SCOP sera bientôt accessible avec des programmes adaptés aux besoins du territoire.
                </p>
                <div className="bg-purple-50 p-6 rounded-lg">
                  <h3 className="font-semibold text-purple-900 mb-3">Formations à venir :</h3>
                  <ul className="text-left text-gray-700 space-y-2 mb-4">
                    <li>• Développement des compétences techniques</li>
                    <li>• Formations en gestion d'entreprise</li>
                    <li>• Accompagnement à la transition coopérative</li>
                    <li>• Formations sectorielles spécialisées</li>
                  </ul>
                  <Link to="/contact">
                    <Button className="bg-purple-600 hover:bg-purple-700">
                      Être informé du lancement
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default FormationPage;
